import { useState, useEffect } from "react";
import { sanitizeAndTrim, htmlScriptRegex } from "../constants/utils";

const useSafeInput = ({ value = "", limit = 1000, onChange, showToast }) => {
  const [localValue, setLocalValue] = useState(value || "");
  const [count, setCount] = useState(value?.length || 0);

  // sync with parent value (avoid unnecessary re-renders)
  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || "");
      setCount(value?.length || 0);
    }
  }, [value]);

  //  BLOCK < >
  const handleKeyDown = (e) => {
    if (e.key.length === 1 && htmlScriptRegex.test(e.key)) {
      e.preventDefault();
      showToast(
        "Greater than (>) and less than (<) symbols are not allowed.",
        "warning",
        true
      );
    }
  };

  //  HANDLE PASTE
  const handlePaste = (e) => {
    e.preventDefault();

    const pasted = e.clipboardData.getData("text");
    const combined = localValue + pasted;

    const result = sanitizeAndTrim(combined, limit);

    if (result.blocked) {
      showToast(
        "Greater than (>) and less than (<) symbols are not allowed.",
        "warning",
        true
      );
      return;
    }

    updateValue(result.value);

    if (result.trimmed) {
      showToast(`Maximum ${limit} characters allowed.`, "warning", true);
    }
  };

  //  HANDLE CHANGE
  const handleChange = (e) => {
    const val = e.target.value;

    const result = sanitizeAndTrim(val, limit);

    if (result.blocked) {
      showToast(
        "Greater than (>) and less than (<) symbols are not allowed.",
        "warning",
        true
      );
      return;
    }

    updateValue(result.value);

    if (result.trimmed) {
      showToast(`Maximum ${limit} characters allowed.`, "warning", true);
    }
  };

  //  SINGLE SOURCE UPDATE FUNCTION (important)
  const updateValue = (val) => {
    setLocalValue(val);
    setCount(val.length);
    onChange({ target: { value: val } });
  };

  return {
    value: localValue,
    count,
    setValue: updateValue, // reuse same logic
    bind: {
      value: localValue,
      onKeyDown: handleKeyDown,
      onPaste: handlePaste,
      onChange: handleChange,
    },
  };
};

export default useSafeInput;
